import axiosInstance from "./api_helper";

const commandeService = {
    list: async ({ clientId, chantierId, dateFrom, dateTo, query, status, page = 0, size = 10 }) => {
        const params = {};
        if (clientId !== undefined && clientId !== null) params.clientId = clientId;
        if (chantierId !== undefined && chantierId !== null) params.chantierId = chantierId;
        if (dateFrom) params.dateFrom = dateFrom;
        if (dateTo) params.dateTo = dateTo;
        if (query) params.query = query;
        if (status) params.status = status;
        params.page = page;
        params.size = size;

        const response = await axiosInstance.get('/api/ventes/bon-commande/list', { params });
        return response.data;
    },
    add: async (commande) => {
        return await axiosInstance.post('/api/ventes/bon-commande', commande);
    },
    validerCommande: async (id) => {
        return await axiosInstance.post(`/api/ventes/bon-livraison/${id}`);
    },
    generatePdf : async (commande) => {
        const response = await axiosInstance.post(`/api/ventes/bon-commande/report`, commande, {
            responseType: 'arraybuffer',
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return response.data;
    },
    delete: async (id) => {
        const response = await axiosInstance.delete(`/api/ventes/bon-commande/${id}`);
        return response.data;
    },
   
    update: async (id, commande) => {
        return await axiosInstance.put(`/api/ventes/bon-commande/${id}`, JSON.stringify(commande));
    },
}

export default commandeService;
